module.exports = {"title":"COMPANY","sub_title":"会社概要","description":"株式会社 J・L・Nの会社概要ページです","canonical":"/company/","name":"株式会社 J・L・N","founded":"平成5年7月","established":"平成10年3月","representative":"代表取締役　青井 正之","executive":["取締役　服部 寿多可"],"capital":"1,000万円","business_summary":"IT関連を中心とした総合的な広告制作<br />業務用システム開発／コンサルティング","number_of_employees":"25名","_company_list":"app.jsonに記述"}


//////////////////
// WEBPACK FOOTER
// ./src/config/company.json
// module id = 540
// module chunks = 0